import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import BuyingBusinessModes from "../../../../components/Buying_businessmodes";
import JobOpportunities from "../../Component/JobOppurtunity";
import Shops from "../../Component/Shops";
import SellProperties from "../../Component/SellProperties";
import BuyVehicles from "../../Component/BuyVehicle";
import Transport from "../../Component/Transport";
import Services from "../../Component/Services";
import ScrapMaterial from "../../Component/ScrapMaterial";
import Recycled from "../../Component/Recycled";
import Farmming from "../../Component/Farmming";
import HelpCenter from "../../Component/HelpCenter";
import { images } from "../../../../constants";
import SellSingleitem from "../../Component/SellSingleitem";
import Generaluserprofile from "./General_user_profile";
import FoodRestaurantComp from "../Food_Restaurantcomp";
import "../dashboard-responsive.css";
import "./top-cards-equal-height.css";

// Voice search mapping to connect spoken words directly to the respective market pages
const BUYING_CATEGORY_ROUTES = [
  {
    name: "Food & Restaurant",
    route: "/BuyRestaurantFood",
    keywords: [
      "food", "restaurant", "dining", "menu", "cafe", "eat", "meal",
      "burger", "pizza", "biryani", "lunch", "dinner", "breakfast",
      "fast food", "drinks", "beverage", "cook", "bakery", "sweets"
    ],
  },
  {
    name: "Vehicle Markets",
    route: "/buy-used-cars",
    keywords: [
      "car", "cars", "vehicle", "vehicles", "motor", "bike", "motorcycle",
      "auto", "automobile", "used car", "used vehicle", "van", "jeep", "suv"
    ],
  },
  {
    name: "Real Estate & Properties",
    route: "/find-property",
    keywords: [
      "property", "properties", "real estate", "house", "plot", "land",
      "flat", "apartment", "building", "commercial", "housing", "estate", "plaza"
    ],
  },
  {
    name: "Retailer Markets",
    route: "/buy-retailer",
    keywords: [
      "retail", "retailer", "retailers", "grocery", "groceries", "household",
      "cloth", "clothing", "fashion", "apparel", "store", "general store",
      "shoes", "cosmetics", "daily use"
    ],
  },
  {
    name: "Wholesale Markets",
    route: "/buy-wholeseller",
    keywords: [
      "wholesale", "wholesaler", "wholesalers", "bulk", "distributor",
      "wholesale market", "b2b supply"
    ],
  },
  {
    name: "Industrial Markets",
    route: "/buy-manufacturer",
    keywords: [
      "manufacturer", "manufacturers", "factory", "industry", "industrial",
      "manufacturing", "plants", "machinery"
    ],
  },
  {
    name: "Raw Material Markets",
    route: "/buy-raw-material",
    keywords: [
      "raw material", "raw materials", "mining", "iron", "steel", "ore",
      "metal", "timber", "wood", "minerals raw", "copper", "aluminum"
    ],
  },
  {
    name: "Gems & Jewelry Markets",
    route: "/buy-Minerals",
    keywords: [
      "gem", "gems", "jewelry", "jewellery", "gold", "silver", "diamond",
      "gemstone", "gemstones", "precious stone", "mineral", "minerals", "necklace", "ring"
    ],
  },
  {
    name: "2nd Hand Items",
    route: "/buy-used-products",
    keywords: [
      "second hand", "2nd hand", "used item", "used items", "used product",
      "used products", "pre-owned", "preowned", "resale", "old items"
    ],
  },
  {
    name: "HomeMade Items",
    route: "/buy-homemade-products",
    keywords: [
      "homemade", "home made", "home-made", "hand craft", "handicraft",
      "handmade", "hand made", "home goods", "home kitchen"
    ],
  },
  {
    name: "Available Jobs",
    route: "/find-job",
    keywords: [
      "job", "jobs", "hiring", "recruitment", "vacancy", "vacancies",
      "career", "employment", "work", "find job", "available jobs", "apply job"
    ],
  },
  {
    name: "Job Candidates",
    route: "/find-candidates",
    keywords: [
      "candidate", "candidates", "cv", "resume", "applicant", "applicants",
      "hire candidate", "job seekers", "talent"
    ],
  },
  {
    name: "Single Item For Sale",
    route: "/single-item-buy",
    keywords: [
      "single item", "single items", "personal item", "individual item",
      "single ad", "single ads", "single product"
    ],
  },
  {
    name: "Transportation & Shipment",
    route: "/find-Transport",
    keywords: [
      "transport", "transportation", "shipment", "cargo", "delivery",
      "logistics", "truck", "freight", "courier", "moving", "rental vehicle", "htv", "ltv"
    ],
  },
  {
    name: "Recycled Markets",
    route: "/recycle-online",
    keywords: [
      "recycle", "recycled", "recycling", "scrap", "waste", "plastic waste",
      "garbage", "reusable", "scrap material", "junk"
    ],
  },
  {
    name: "Services Market",
    route: "/find-services",
    keywords: [
      "service", "services", "contractor", "contractors", "electrician",
      "plumber", "carpenter", "repair", "maintenance", "technician", "expert", "cleaning"
    ],
  },
  {
    name: "Agriculture & Farming",
    route: "/Farming-online",
    keywords: [
      "farm", "farming", "agriculture", "seeds", "crop", "crops",
      "fertilizer", "fertilizers", "tractor", "farming tools", "harvest"
    ],
  },
  {
    name: "Personal Property",
    route: "/buy-single-property",
    keywords: [
      "personal property", "single property", "rent or sale", "property ad", "for rent"
    ],
  },
];

const BuyingSide = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [voiceSearchNotice, setVoiceSearchNotice] = useState(null);

  useEffect(() => {
    // Reset any lingering background on document.body so page refresh never flashes body gradient
    const prevBg = document.body.style.background;
    document.body.style.background = "";
    return () => {
      document.body.style.background = prevBg || "";
    };
  }, []);

  useEffect(() => {
    // Process search query from voice search or URL parameters
    const handleVoiceRouting = (rawQuery) => {
      if (!rawQuery || typeof rawQuery !== "string") return;
      const clean = rawQuery.trim().toLowerCase();
      if (!clean) return;

      let matched = null;
      let longestMatchLen = 0;

      for (const cat of BUYING_CATEGORY_ROUTES) {
        for (const kw of cat.keywords) {
          if (clean.includes(kw) || kw.includes(clean)) {
            if (kw.length > longestMatchLen) {
              longestMatchLen = kw.length;
              matched = cat;
            }
          }
        }
      }

      const targetRoute = matched ? matched.route : "/buy-retailer";
      const targetCategory = matched ? matched.name : "Retailer Market";

      setVoiceSearchNotice({
        query: rawQuery,
        category: targetCategory,
        route: targetRoute,
      });

      // Navigate automatically to the market page with the search query
      navigate(`${targetRoute}?search=${encodeURIComponent(rawQuery.trim())}`);
    };

    const params = new URLSearchParams(location.search);
    const searchParam = params.get("search");
    if (searchParam) {
      handleVoiceRouting(searchParam);
    }

    const handleCustomVoiceEvent = (e) => {
      const q = e?.detail?.query;
      if (q) {
        handleVoiceRouting(q);
      }
    };

    window.addEventListener("selectezi:voicesearch", handleCustomVoiceEvent);
    return () => {
      window.removeEventListener("selectezi:voicesearch", handleCustomVoiceEvent);
    };
  }, [location.search, navigate]);

  return (
    <div
      className="specificpage dashboard-responsive buying-side-dashboard"
      style={{
        overflow: "hidden",
        minHeight: "100vh",
        background: "linear-gradient(119.72deg, #15751F 5.7%, #0D3C82 93.64%)",
      }}
    >
      <Container fluid className=" ps-lg-5 pe-lg-5 ps-md-5 pe-md-5 pt-3">
        <div className="screenHeight">
          <div>
            <div className="noscroll dashboard-scroll pt-lg-2 pb-lg-2 ps-lg-3 pe-lg-3 p-md-3">
              {/* Voice search feedback notice */}
              {voiceSearchNotice && (
                <div
                  className="d-flex align-items-center justify-content-between p-2 mb-3 rounded-3"
                  style={{
                    background: "rgba(255, 255, 255, 0.14)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255, 255, 255, 0.28)",
                    color: "#ffffff",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <span
                      style={{
                        background: "#0353A4",
                        color: "#ffffff",
                        borderRadius: "6px",
                        padding: "2px 8px",
                        fontSize: "12px",
                        fontWeight: 600,
                      }}
                    >
                      Voice Search
                    </span>
                    <span style={{ fontSize: "14px" }}>"{voiceSearchNotice.query}"</span>
                    {voiceSearchNotice.category && (
                      <span style={{ color: "#ffd166", fontSize: "13px" }}>
                        Opening: <strong>{voiceSearchNotice.category}</strong>...
                      </span>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    {voiceSearchNotice.route && (
                      <button
                        type="button"
                        className="btn btn-sm"
                        style={{
                          background: "#0353A4",
                          color: "#ffffff",
                          borderRadius: "6px",
                          fontSize: "12px",
                          padding: "3px 12px",
                        }}
                        onClick={() =>
                          navigate(
                            `${voiceSearchNotice.route}?search=${encodeURIComponent(
                              voiceSearchNotice.query,
                            )}`,
                          )
                        }
                      >
                        Go Now
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-sm"
                      style={{
                        background: "transparent",
                        color: "rgba(255,255,255,0.8)",
                        border: "none",
                        fontSize: "14px",
                        padding: "2px 6px",
                      }}
                      onClick={() => {
                        setVoiceSearchNotice(null);
                        navigate("/BuyingSide", { replace: true });
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              )}
              <Row className="dashboard-profile-row">
                <Col
                  lg="4"
                  md="12"
                  sm="12"
                  xs="12"
                  className="dashboard-profile-column"
                >
                  <Generaluserprofile />
                </Col>
                <Col
                  lg="8"
                  md="12"
                  sm="12"
                  xs="12"
                  className="dashboard-business-column mt-3 mt-lg-0"
                >
                  <BuyingBusinessModes
                    btntext="Search Now"
                    title="Buy From Business Shop"
                  />
                </Col>
              </Row>

              <Row className="dashboard-feature-row mt-3">
                <Col lg="4" className="dashboard-feature-column">
                  <JobOpportunities
                    titleone="Jobs Recruitment Offers"
                    titletwo="Candidates Avaliable"
                    btn="Search Now"
                  />
                </Col>

                <Col
                  lg="6"
                  className="dashboard-feature-column mt-md-3 mt-lg-0 mt-sm-3"
                >
                  <Shops btn="Search Now" title="Buy From Shops" />
                </Col>

                <Col
                  lg="2"
                  className="dashboard-feature-column mt-md-3 mt-lg-0 mt-sm-3"
                >
                  <SellSingleitem btn="Search Now" title="Single Item For Sale" />
                </Col>
              </Row>

              <Row className="dashboard-market-row mt-4">
                <Col lg="2" md="4" xs="6" className="dashboard-market-column">
                  <SellProperties title="Real Estate & Properties" />
                </Col>

                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <BuyVehicles title="Vehicle Markets" />
                </Col>

                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <Transport btn="Search Now" />
                </Col>

                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <Recycled btn="Search Now" />
                </Col>

                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <Services btn="Search Now" />
                </Col>

                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <Farmming btn="Search Now" />
                </Col>
              </Row>
              <Row className="dashboard-help-row mt-4">
                <Col
                  lg="2"
                  md="4"
                  className="dashboard-market-column"
                >
                  <ScrapMaterial
                    btn="Search Now"
                    titleone="For Rent or  Sale"
                    titletwo="For Rent or  Sale"
                  />
                </Col>
                <Col
                  lg="2"
                  md="4"
                  className="dashboard-market-column"
                >
                  <FoodRestaurantComp
                    btn="Search Now"
                    titleone="Food and Restaurant"
                    titletwo="Food and Restaurant"
                  />
                </Col>
                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <HelpCenter
                    btn="Check Now"
                    titleone="User Guide"
                    titletwo="User Guide"
                    img_h={images.Manual}
                  />
                </Col>
                <Col
                  lg="2"
                  md="4"
                  xs="6"
                  className="dashboard-market-column"
                >
                  <HelpCenter
                    btn="Contact"
                    titleone="Help Center"
                    titletwo="Helpline"
                    img_h={images.HelpLine}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};
export default BuyingSide;
